import * as ProgressPrimitive from '@radix-ui/react-progress';
import clsx from 'clsx';
import * as React from 'react';
const Progress = React.forwardRef(({
  className,
  rootClassName,
  indicatorClassName,
  value,
  ...props
}, ref) => <ProgressPrimitive.Root ref={ref} className={clsx('relative h-2 w-full overflow-hidden rounded-full bg-primary/20', rootClassName, className)} {...props} value={value}>
            <ProgressPrimitive.Indicator className={clsx('h-full w-full flex-1 bg-primary transition-all', indicatorClassName)} style={{
    transform: `translateX(-${100 - (value || 0)}%)`
  }} />
        </ProgressPrimitive.Root>);
Progress.displayName = ProgressPrimitive.Root.displayName;
export { Progress };